export default __webpack_public_path__ + "static/pledge_air-b5e6d7655ba3e8ebaeadbc0c4b716144.webp";